import { action } from 'satcheljs';

/**
 * Resets the value of the charm suggestions highlighted index
 */
export const resetCharmSuggestionsHighlightedIndex = action(
    'resetCharmSuggestionsHighlightedIndex',
    (formId: string) => ({ formId })
);

/**
 * Updates the value of the highlighted index
 */
export const setCharmSuggestionsHighlightedIndex = action(
    'setCharmSuggestionsHighlightedIndex',
    (isIncrement: boolean, formId: string) => ({
        isIncrement: isIncrement,
        formId: formId,
    })
);
